import {createAsyncThunk} from '@reduxjs/toolkit';
import {itemsApi} from 'api';
import {IBindBaseEntity} from 'models';
import {prefix} from '../../../instruments/store/thunks/config';

export const fetchSortOrderTypesThunk: any = createAsyncThunk<IBindBaseEntity[]>(
  `${prefix} fetchSortOrderTypes`,
  async () => {
    const {parsedBody} = await itemsApi.getItemsSortOrderTypes();
    return parsedBody;
  }
);
